<template>
	<StandardModal
		v-if="announcement"
		open
		:title="$t('announcements_name')"
		:confirmText="$t('common_button_done')"
		@cancel="$emit('cancel')"
	>
		<div class="announcement-detail-modal">
			<AnnouncementView :announcement="announcement" />
		</div>

		<template #footer-right>
			<Button @click="goToAnnouncement">
				{{ $t('announcements_sent_openin') }}
			</Button>
			<Button primary @click="$emit('cancel')">
				{{ $t('common_button_done') }}
			</Button>
		</template>
	</StandardModal>
</template>

<script>
import { StandardModal, Button } from '@/components/common'
import AnnouncementView from './AnnouncementView'
import { markAnnouncementAsRead } from '@/api/announcement'

export default {
	name: 'AnnouncementModal',
	components: { StandardModal, Button, AnnouncementView },
	props: {
		announcement: Object,
	},
	mounted() {
		markAnnouncementAsRead(this.announcement.id)
	},
	methods: {
		goToAnnouncement() {
			const id = this.announcement.id
			this.$router.push(`/announcements/${id}`)
		},
	},
}
</script>

<style lang="scss" scoped>
.announcement-detail-modal {
	padding-bottom: 16px;
}
</style>
